import React, { useState, useEffect, useCallback } from "react";
import { Helmet } from "react-helmet";
import { makeStyles } from "@material-ui/core/styles";
import { useSelector, useDispatch } from "react-redux";
import Sidebar from "../../components/sidebar";
import Loading from "../../components/loading";
import VendorStatus from "../../components/vendorStatus";
import VendorOverview from "../../components/vendorOverview";
import VendorTransactions from "../../components/vendorTransactions";
import VendorReports from "../../components/vendorReports";
import VendorSettlements from "../../components/vendorSettlements";
import VendorSettings from "../../components/vendorSettings";
import { getVendorProfileAction } from "./action";

const useStyles = makeStyles(() => ({ root: { display: "flex" } }));

function VendorDashboard({ match, location }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState("overview");

  const getVendorProfileMethod = useCallback(
    () => dispatch(getVendorProfileAction()),
    [dispatch]
  );

  const vendorDashboardReducer = useSelector((state) => {
    return state.vendorDashboardReducer;
  });

  const loginReducer = useSelector((state) => {
    return state.loginReducer;
  });

  useEffect(() => {
    getVendorProfileMethod();
  }, [getVendorProfileMethod]);

  useEffect(() => {
    if (match?.params?.activeTab && match.params.activeTab !== activeTab) {
      setActiveTab(match.params.activeTab);
    }
  }, [match, activeTab, setActiveTab]);

  // Check vendor status - prefer from profile, fallback to localStorage
  const profileStatus = vendorDashboardReducer?.vendorProfile?.status;
  const user = JSON.parse(localStorage.getItem("user")) || {};
  const vendorStatus = profileStatus || user.status || "pending"; // pending, approved, rejected

  // Show status page if pending or rejected
  // if (vendorStatus === "pending" || vendorStatus === "rejected") {
  //   return <VendorStatus status={vendorStatus} />;
  // }

  return (
    <div className={classes.root}>
      <Helmet>
        <title>{`Sanaam - ${activeTab}`}</title>
        <meta property="og:title" content={`Sanaam - ${activeTab}`} />
      </Helmet>
      <Loading
        showLoader={
          vendorDashboardReducer?.loading || loginReducer?.loading
        }
      />
      <Sidebar
        baseURL={"/merchant/dashboard"}
        activeTab={activeTab}
        tabs={[
          {
            name: "Overview",
            icon: "Overview Icon.svg",
            isActive: true,
            pathName: "overview",
          },
          {
            name: "Transactions",
            icon: "Transaction Icon.svg",
            isActive: true,
            pathName: "transactions",
          },
          {
            name: "Reports",
            icon: "Report Icon.svg",
            isActive: true,
            pathName: "reports",
          },
          {
            name: "Settlements",
            icon: "Sanaam Payments.svg",
            isActive: true,
            pathName: "settlements",
          },
          {
            name: "Settings",
            icon: "setting_dark.png",
            isActive: true,
            pathName: "settings",
          },
        ]}
      />
      {activeTab === "overview" && <VendorOverview />}
      {activeTab === "transactions" && <VendorTransactions />}
      {activeTab === "reports" && <VendorReports />}
      {activeTab === "settlements" && <VendorSettlements />}
      {activeTab === "settings" && <VendorSettings />}
    </div>
  );
}

export default VendorDashboard;

